import React, { useState, useEffect } from "react";
import axios from "axios";
import { X } from "lucide-react";
import { Button } from "../../components/ui/button";
import { useMusicPlayer } from "../../contexts/AppContext";
import { API } from "../../config";

export default function LyricsPanel() {
  const { currentTrack, showLyrics, toggleLyrics } = useMusicPlayer();
  const [fetchedLyrics, setFetchedLyrics] = useState(null);

  useEffect(() => {
    if (!currentTrack) {
      setFetchedLyrics(null);
      return;
    }
    if (currentTrack.lyrics) {
      setFetchedLyrics(null);
      return;
    }
    setFetchedLyrics(null);
    axios
      .get(`${API}/lyrics/${currentTrack.id}`)
      .then((res) => setFetchedLyrics(res.data?.lyrics ?? null))
      .catch(() => setFetchedLyrics(null));
  }, [currentTrack?.id]);

  if (!showLyrics || !currentTrack) return null;

  const displayLyrics = currentTrack.lyrics || fetchedLyrics;
  const isLoading = !currentTrack.lyrics && fetchedLyrics === null;

  return (
    <div className="fixed right-0 top-20 bottom-20 w-full sm:w-96 z-30 glass border-l border-white/10 overflow-hidden animate-fade-in" data-testid="lyrics-panel">
      <div className="flex items-center justify-between p-4 border-b border-white/10">
        <h3 className="font-bold font-['Syne']">Dalszöveg</h3>
        <Button variant="ghost" size="icon" onClick={toggleLyrics}><X className="h-4 w-4" /></Button>
      </div>
      <div className="p-4 h-full overflow-y-auto pb-32">
        <h4 className="text-lg font-bold mb-4">{currentTrack.title}</h4>
        <div className="text-muted-foreground whitespace-pre-line leading-relaxed text-sm">
          {isLoading ? "Betöltés..." : (displayLyrics || "Dalszöveg nem elérhető ehhez a számhoz.")}
        </div>
      </div>
    </div>
  );
}
